<template>
  <div class="ninthPage">
    <div class="head">
      <img src="/static/imgs/secondPage/sun.png" />
      <span class="back">ABOUT US</span>
      <span class="front">创始人团队</span>
    </div>
    <el-row class="persons" :gutter="30">
      <el-col v-for="(item,index) in persons" :key="index" :span="6">
        <div class="person">
          <el-card class="card">
            <img :src="item.img" />
            <span v-html="item.name" />
            <span v-html="item.enName" class="lit" />
            <span v-html="item.title" class="lit" />
            <span v-html="item.subTitle" class="lit" />
          </el-card>
          <p class="content" v-html="item.content" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "ninthPage",
  data() {
    return {
      persons: [
        {
          img: "/static/imgs/ninthPage/1.jpg",
          name: "汪  宇",
          enName: "Rick Wang",
          title: "Xlearning创始人",
          subTitle: "沉浸式学习方法论专家",
          content:
            "汪老师20年职业生涯，一直专注人力资源领域，是组织发展、人才选拔、人才发展、领导力发展方面的专家，在16年的时间里，曾服务过七个不同行业的多家跨国公司，担任中国区人力资源高管，亲自参与设计、并组织实施了数十个亚太区、中国区的企业内部人才选拔、人才发展项目，推动了500+名企业中高层管理者的职业发展。<br/>从2015年开始创业，他发起多个互联网项目，创立了职场类自媒体节目《老汪谈职场》，为职场人答疑解惑，帮助了超过30万年轻职场人的个人发展，收听人次超千万。与此同时，他发起并大力倡导沉浸式学习在企业培训与咨询行业的应用与普及，发起中国首家专注于沉浸式学习的培训机构-XLearning无界学习，为超过200+公司提供了专业的沉浸式学习与咨询服务。",
        },
        {
          img: "/static/imgs/ninthPage/2.jpg",
          name: "花 蕾",
          enName: "Hua Lei",
          title: "Xlearning联合创始人",
          subTitle: "公司首席执行官",
          content:
            "人力资源领域科班出身，却开放式成长，专业跨越化工，金融，组织发展及人力资源。专注在人才与组织发展领域19年，主持过人才选拔，评鉴中心，人才发展，领导力发展，及组织变革及流程再造等项目。丰富的行业经历涉及能源，金融，互联网，教育及高校等；在多家公司中担任组织发展/职业发展中心负责人；服务过的公司有 Texaco 英国北区，AIG（AIA），PayPal，中英国际学院，及Staples 中国区等。<br/>目前是位连续创业实践者，与跨界伙伴一起创办了X Learning (无界学习），专注在沉浸式学习领域的探索和商业实践。作为充满热情的实践者，喜欢不安分的尝试，持续地突破传统学习组织发展的边界。不断地尝试和更多的跨界元素比如艺术，体育，戏剧，科技等不同的领域做结合实践，与客户一起共创，逐渐沉淀出一批有突破性的沉浸式产品。",
        },
        {
          img: "/static/imgs/ninthPage/3.jpg",
          name: "马婉婷",
          enName: "Wanting Ma",
          title: "Xlearning联合创始人",
          subTitle: "公司首席运营官",
          content:
            "一位新闻传媒专业，用舞蹈跨界闯进组织发展领域的沉浸式学习发展顾问；她充满活力，洞察感性，涉猎广泛，但又务实专业，精耕细作。从业经历从，继而深耕于沉浸式学习政府机关，到创业探索，再跨界到管理咨询行业领域；突破，多元，务实，专业一直是她的代名词。<br/>作为X Learning创始团队成员，从沉浸式学习项目的研发，交付，到为客户提供咨询诊断方案等，她始终保持着好奇和探索的精神。她带领团队，设计研发沉浸式学习20余种，载体涉及体育，艺术，音乐，搭建，科技等多个领域，通过交付800多场的沉浸式学习项目，服务超过200家世界知名企业客户，有来自医药，互联网，金融，制造业等领域的3万多名管理者参加。<br/>秉承X Learning无界学习 “不设边界”的理念，她动爱跳舞，静喜绘画，并且对极限运动，滑翔伞，高空跳伞及海底自由潜水都有尝试，持续行动，一直保持在拓展自己边界的路上。",
        },
        {
          img: "/static/imgs/ninthPage/4.jpg",
          name: "陈曦冉",
          enName: "Russell Chen",
          title: "沉浸式载体设计交付专家",
          subTitle: "<br/>",
          content:
            "计算机编程专业出身，严谨缜密，擅长逻辑，但又是位不乏灵活幽默，热情活跃的东北小哥； 迄今为止，他负责过超600场的高质量沉浸式学习项目交付，载体涉及体育，艺术，音乐，搭建，科技等多个领域；项目参与学员超过2万人次，来自于超过130多家企业客户。<br/>他从沉浸式学习载体设计作为起点，逐步从针对客户应用场景的载体设计到实操落地，使其通过具体地实践逐渐成长为项目交付领域的专家。<br/>除了擅长项目交付执行，作为深度体育爱好者，他结合沉浸式学习的方法论，将诸多运动体育元素应用进沉浸式学习产品中，比如：“变革管理”中的盲足载体及“高绩效团队”中的单车载体都出自他的创意迭代和实施。作为 X Learning的载体设计及交付专家，他始终秉承着“无界”的宗旨，持续尝试沉浸式学习载体的体验和实践，他一直在突破。",
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.ninthPage {
  margin: 0 0 0 0;
  background-color: whitesmoke;
  padding: 10px 0;
}

.head {
  text-align: center;

  img {
    margin-left: -130px;
  }
  .back {
    position: absolute;
    font-size: 55px;
    color: cornflowerblue;
    margin-left: -90px;
    margin-top: -10px;
    z-index: 0;
    opacity: 0.2;
  }
  .front {
    position: absolute;
    font-size: 45px;
    margin-top: 22px;
    margin-left: -65px;
    margin-top: 10px;
    letter-spacing: 8px;
  }
}

.persons {
  margin-top: 60px;
  padding: 0 20px;
  .person {
    .card {
      display: flex;
      flex-flow: column nowrap;
      background-color: whitesmoke;
      .lit {
        color: #909399;
        margin-top: 4px;
        font-size: 10px;
        font-weight: lighter;
      }
      img {
        width: 100px;
      }
      span {
        display: block;
      }
    }
  }
  .content {
    margin-top: 20px;
    font-size: 13px;
    text-align: left;
    font-family: "";
    background-color: whitesmoke;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ninthPage.vue